import React from "react";
import classNames from "classnames";
import * as c from "./pageHeaderContent.module.scss";
import { processMarkdown } from "@utils/markdown";
import { ContentfulCta } from "@components/shared/cta";
import EmailCaptureForm from "@components/shared/emailCapture/emailCaptureForm";

const PageHeaderContent = ({
  label,
  heading,
  subheading,
  cta,
  ctaSecondary,
  isFeaturePage,
  isShowcasePage,
  isDirectMailPage,
  ctaEmailCapture,
  className,
}) => {
  // This is pretty ugly, but we need a way to remove the left-margin offset we add to links
  // of this type so that they will be correctly left/center aligned with the section
  //
  // Proper fix should be removing the offset on the ContentfulCta button component and instead
  // display any icon outside of the normal document flow, e.g. pseudo element / absolute pos
  const ctaHasDesktopOffset = (cta) =>
    cta?.__typename === "ContentfulCtaButton" && cta?.showIcon && cta?.style?.[0] === "Link";

  const Headline = isFeaturePage || isShowcasePage ? "h1" : "h2";

  return (
    <div className={classNames(isFeaturePage || isShowcasePage ? c.featurePageContent : c.header, className)}>
      {!isFeaturePage && !isShowcasePage && (
        <h1 className={classNames(c.eyebrow, "eyebrow", !label && c.empty)}>{label}</h1>
      )}
      <Headline
        className={classNames(c.headline, "h1", isDirectMailPage && c.ivyHeadline)}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
      {subheading && subheading.subheading && (
        <p
          className={classNames(c.subheading, "p2", !isShowcasePage && c.standardPageSubheading)}
          dangerouslySetInnerHTML={{ __html: processMarkdown(subheading?.subheading) }}
        />
      )}
      {(cta || ctaSecondary) && (
        <div className={classNames(c.ctaContainer, isFeaturePage && c.featurePageCta, ctaSecondary && c.ctaWrap)}>
          <ContentfulCta
            className={classNames(c.cta, ctaHasDesktopOffset(cta) && c.ctaOffset)}
            {...cta}
            style={cta?.style?.[0] !== "Button Secondary" ? "Button Primary" : "Button Secondary"}
          />
          {ctaSecondary && (
            <ContentfulCta
              className={classNames(c.cta, ctaHasDesktopOffset(ctaSecondary) && c.ctaOffset)}
              {...ctaSecondary}
            />
          )}
        </div>
      )}
      {ctaEmailCapture && (
        <EmailCaptureForm className={c.emailCapture} formSource="bm_newsletter" {...ctaEmailCapture} />
      )}
    </div>
  );
};

export default PageHeaderContent;
